<div class="header">
    <div class="title-container">
        <div class="title">{{ exerciceRow.exercice.name }}</div>
        <div class="subtitle">
            {{ exerciceRow.exercice.description }}
        </div>
        <div class="lib">
            <span class="libtag" [ngClass]="exerciceRow?.libraryTag">
                {{ 'exercises_tag_' + exerciceRow?.libraryTag | translate }}
            </span>
        </div>
        <div class="duration">
            <span>{{ totalTime | durationVerbose:'seconds' }}</span>
            <div class="accents">
                <ng-container *ngFor="let category of exerciceRow.categories">
                    <exercice-category-thumbnail *ngIf="category !== null"
                                                 [data]="category"
                                                 [hideText]="true"
                                                 [chipSize]="16"
                                                 [matTooltip]="category.name ?? ''">
                    </exercice-category-thumbnail>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="image-container">
        <img *ngIf="exerciceRow.exercice?.image || exerciceRow.exercice?.video_thumbnail_path"
            [src]="conf.storageRootUrl + (exerciceRow.exercice.image || exerciceRow.exercice.video_thumbnail_path)" />
        <mat-icon *ngIf="!(exerciceRow.exercice?.image || exerciceRow.exercice?.video_thumbnail_path)">
            image
        </mat-icon>
    </div>
</div>
